// FILE: src/components/SupportContactList.jsx
// Renders support contact details (phone, email, hours) as small cards
// (MTO 1.3.4, 10.1). Pass `channels` from useSupportChannels(), or a single
// `contact` from a 423 response. Each line has a word label as well as an
// icon (colour and icons are never the only signal, MTO 5.4).
import { Box, Link, Stack, Typography } from "@mui/material";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";

function Line({ icon: Icon, label, children }) {
  return (
    <Stack direction="row" spacing={1.25} sx={{ alignItems: "flex-start" }}>
      <Icon aria-hidden sx={{ color: "primary.main", mt: "0.2rem", flexShrink: 0 }} />
      <Typography sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
        {label}: {children}
      </Typography>
    </Stack>
  );
}

function Contact({ name, phone, email, hours }) {
  return (
    <Box sx={{ p: 2, borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
      {name && (
        <Typography component="h3" sx={{ fontWeight: 650, mb: 1 }}>
          {name}
        </Typography>
      )}
      <Stack spacing={0.75}>
        {phone && (
          <Line icon={PhoneOutlinedIcon} label="Phone">
            <Link href={`tel:${phone.replace(/[^\d+]/g, "")}`}>{phone}</Link>
          </Line>
        )}
        {email && (
          <Line icon={MailOutlineIcon} label="Email">
            <Link href={`mailto:${email}`}>{email}</Link>
          </Line>
        )}
        {hours && (
          <Line icon={ScheduleOutlinedIcon} label="Hours">
            {hours}
          </Line>
        )}
      </Stack>
    </Box>
  );
}

export default function SupportContactList({ channels, contact }) {
  if (contact && (contact.phone || contact.email)) {
    return <Contact name="Student service support" {...contact} />;
  }
  if (channels === null || channels === undefined) {
    return <Typography sx={{ color: "text.secondary" }}>Loading support contact details…</Typography>;
  }
  if (channels.length === 0) {
    return <Typography>Support contact details are unavailable right now. Please try again later.</Typography>;
  }
  return (
    <Stack spacing={1.5}>
      {channels.map((c) => (
        <Contact key={c.type} {...c} />
      ))}
    </Stack>
  );
}
